import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SERVER_URL } from '../../config';

import sty from './ProdDetailPage.module.css';

import { downIcon, buyIcon, downOverIcon, buyOverIcon } from '../../assets/images/product/prodImages';

const PrdDtlFile = ({ fileSeq, filePath, fileType }) => {
    const [isHovered, setIsHovered] = useState(false);

    if (!fileSeq) {
        return null;
    }

    let linkText;
    let iconImg;
    let iconOverImg;
    let link;

    switch (fileType) {
        case 'C':
            linkText = '카달로그';
            iconImg = downIcon;
            iconOverImg = downOverIcon;
            link = SERVER_URL + filePath;
            break;
        case 'S':
            linkText = '데모 및 SDK';
            iconImg = downIcon;
            iconOverImg = downOverIcon;
            link = `/product/download?idx=${fileSeq}`;
            break;
        case 'P':
            linkText = '구매하기';
            iconImg = buyIcon;
            iconOverImg = buyOverIcon;
            link = filePath;
            break;
        default:
            return null;
    }

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div
            draggable
            className={sty.fileBtn}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {fileType !== 'S' ? (
                <a href={link} download target="_blank" rel="noreferrer">
                    {linkText}
                    <img src={isHovered ? iconOverImg : iconImg} alt='icon' />
                </a>
            ) : (
                <Link to={link}>
                    <a>{linkText}</a>
                    <img src={isHovered ? iconOverImg : iconImg} alt='icon' />
                </Link>
            )}
        </div>
    );
};

export default PrdDtlFile;